/* eslint-disable unicorn/numeric-separators-style */
import { StoryData } from '@cinch-nx/data-storyblok'
import { ServicingPageContent } from '../type/servicing-page'

export const servicingFallback: StoryData<ServicingPageContent> = {
  name: 'Index',
  created_at: '2026-02-13T14:16:32.956Z',
  published_at: '2026-04-30T10:18:58.823Z',
  id: 144599420828655,
  uuid: '15acb600-4af9-429e-9d80-ee9ac0d8b5c2',
  content: {
    SEO: [
      {
        _uid: '08ed00b3-3e2a-4d9d-a0cc-e1190abf58b7',
        HowTo: [],
        title: 'Book a car service or MOT from cinch | Faff-free car servicing',
        robots: [],
        component: 'SEO',
        openGraph: [],
        description:
          'Get a car service or MOT from cinch at over 100 locations nationwide. Fixed prices services and MOTs. Book your service or MOT today.',
        twitterCard: [],
        canonicalUrl: '',
        _editable:
          '\u003C!--#storyblok#{"name": "SEO", "space": "143588", "uid": "08ed00b3-3e2a-4d9d-a0cc-e1190abf58b7", "id": "144599420828655"}--\u003E',
      },
    ],
    _uid: 'c5a68e03-b65d-4a47-8002-0d4da88acfb6',
    body: [
      {
        url: '/car-care/servicing/book',
        _uid: 'b051b1e7-aa48-4381-be29-4c196c321115',
        type: 'primary',
        label: 'Book a service or MOT',
        component: 'CtaButton',
        _editable:
          '\u003C!--#storyblok#{"name": "CtaButton", "space": "143588", "uid": "b051b1e7-aa48-4381-be29-4c196c321115", "id": "144599420828655"}--\u003E',
      },
      {
        _uid: 'f0bc3813-5eb1-4460-8b1b-2041d125dab6',
        text: {
          type: 'doc',
          content: [
            {
              type: 'heading',
              attrs: {
                level: 2,
                textAlign: 'center',
              },
              content: [
                {
                  text: 'Faff-free car maintenance',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: {
                textAlign: 'center',
              },
              content: [
                {
                  text: "cinchServicing takes the hassle out of keeping up with car maintenance, and it's available for all drivers.",
                  type: 'text',
                },
              ],
            },
          ],
        },
        component: 'RichText',
        _editable:
          '\u003C!--#storyblok#{"name": "RichText", "space": "143588", "uid": "f0bc3813-5eb1-4460-8b1b-2041d125dab6", "id": "144599420828655"}--\u003E',
      },
      {
        _uid: 'ebf338cb-6ff9-4fe5-836d-a974ad05a955',
        component: 'LandingTextInlineImageSection',
        textInlineImages: [
          {
            _uid: '14cc11db-55fb-43a7-bb18-ad60cfc6a869',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch & Marshall Motor Group',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: "Marshall is part of our extended family, and we've teamed up to offer faff-free servicing and MOTs to all drivers, whether you bought your car from cinch or not.",
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: "Servicing starts from just £129.95 and MOTs are £39.95, so you know that you're getting a great service at a great price.",
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 121253122518170,
              alt: 'table of the cinchServicing pricing',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/869x649/3197fff846/dec-25-cinchservicing-prices.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'table of the cinchServicing pricing',
                title: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imageShape: 'rectangle',
            imagePosition: 'right',
            _editable:
              '\u003C!--#storyblok#{"name": "LandingTextInlineImage", "space": "143588", "uid": "14cc11db-55fb-43a7-bb18-ad60cfc6a869", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: '921e53c5-d32b-41ae-b7e4-590021c9e32d',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'How to book a cinch service or MOT',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Servicing and MOTs are available in over 100 Marshall stores across the country. Use our ',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                    {
                      text: 'booking form',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: '/car-care/servicing/book',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                    {
                      text: ' to find your nearest store and choose your appointment. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 81181323442343,
              alt: 'A mechanic with a clipboard inspecting a cars engine bay',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/132543/1920x1282/4d1e45710d/car-mot-18324.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'A mechanic with a clipboard inspecting a cars engine bay',
                title: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imageShape: 'rectangle',
            imagePosition: 'left',
            _editable:
              '\u003C!--#storyblok#{"name": "LandingTextInlineImage", "space": "143588", "uid": "921e53c5-d32b-41ae-b7e4-590021c9e32d", "id": "144599420828655"}--\u003E',
          },
        ],
        _editable:
          '\u003C!--#storyblok#{"name": "LandingTextInlineImageSection", "space": "143588", "uid": "ebf338cb-6ff9-4fe5-836d-a974ad05a955", "id": "144599420828655"}--\u003E',
      },
      {
        _uid: '5d2a61c8-fa5b-4fea-a586-b6647b126e56',
        title: 'Why choose us for your service?',
        component: 'HighlightsSection',
        highlights: [
          {
            _uid: 'b2c08edd-0cd8-4255-869e-7f5a7ef890d6',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Our team come with decades of experience',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 81181931821270,
              alt: 'picture of a mechanic servicing a car',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/132543/538x308/832b349e11/mechanic-servicing-car.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'picture of a mechanic servicing a car',
                title: '',
                copyright: '',
              },
              is_external_url: false,
            },
            heading: 'Skilled mechanics',
            component: 'FeatureImageCard',
            iconTitle: 'EXPERT STAFF',
            _editable:
              '\u003C!--#storyblok#{"name": "FeatureImageCard", "space": "143588", "uid": "b2c08edd-0cd8-4255-869e-7f5a7ef890d6", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: '52fc1f35-9200-4415-b6e1-bf3ae877e915',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Servicing from £129.95 and MOTs for £39.95',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 81182177257722,
              alt: "Man inspecting the side of a blue car closely, focusing on the vehicle's surface with a thoughtful expression.",
              name: '',
              focus: '',
              title: '',
              filename:
                'https://a.storyblok.com/f/132543/400x266/e53931967d/mechanic-checking-bodywork-at-a-cinch-service-centre.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: "Man inspecting the side of a blue car closely, focusing on the vehicle's surface with a thoughtful expression.",
                title: '',
                copyright: '',
              },
              is_external_url: false,
            },
            heading: 'Transparent costs',
            component: 'FeatureImageCard',
            iconTitle: 'FIXED PRICES',
            _editable:
              '\u003C!--#storyblok#{"name": "FeatureImageCard", "space": "143588", "uid": "52fc1f35-9200-4415-b6e1-bf3ae877e915", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: 'f93d6df8-a9d7-46a8-b88e-f1460eb710e3',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Friendly and honest communication',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 81182434011433,
              alt: 'Two mechanics in a garage discuss while inspecting a car. One holds a clipboard, both wearing work attire.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/132543/499x333/c9ab0b7cdc/mechanic-talking-to-a-customer.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Two mechanics in a garage discuss while inspecting a car. One holds a clipboard, both wearing work attire.',
                title: '',
                copyright: '',
              },
              is_external_url: false,
            },
            heading: 'Jargon-free zone',
            component: 'FeatureImageCard',
            iconTitle: 'STRAIGHTFORWARD',
            _editable:
              '\u003C!--#storyblok#{"name": "FeatureImageCard", "space": "143588", "uid": "f93d6df8-a9d7-46a8-b88e-f1460eb710e3", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: 'ab18bb47-6360-483b-a233-b68fde03a191',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Petrol, diesel, hybrid or electric – bought from us, or not',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 81182697486668,
              alt: 'Red car on a lift in a garage, hood open. Mechanic in orange vest partially visible underneath. Computer and tools nearby.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/132543/400x266/5aac4e12cb/car-on-ramp-at-a-cinch-service-centre-low-res.webp',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Red car on a lift in a garage, hood open. Mechanic in orange vest partially visible underneath. Computer and tools nearby.',
                title: '',
                copyright: '',
              },
              is_external_url: false,
            },
            heading: 'All brands serviced',
            component: 'FeatureImageCard',
            iconTitle: 'OPEN TO ALL',
            _editable:
              '\u003C!--#storyblok#{"name": "FeatureImageCard", "space": "143588", "uid": "ab18bb47-6360-483b-a233-b68fde03a191", "id": "144599420828655"}--\u003E',
          },
        ],
        _editable:
          '\u003C!--#storyblok#{"name": "HighlightsSection", "space": "143588", "uid": "5d2a61c8-fa5b-4fea-a586-b6647b126e56", "id": "144599420828655"}--\u003E',
      },
      {
        _uid: '82248ecb-8d93-4f43-8d98-0f21d6373757',
        text: {
          type: 'doc',
          content: [
            {
              type: 'heading',
              attrs: {
                level: 2,
                textAlign: 'center',
              },
              content: [
                {
                  text: 'What does a cinch service include?',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: {
                textAlign: 'center',
              },
              content: [
                {
                  text: 'We service petrol, diesel, hybrid and electric cars. All our prices are fixed, whether you bought your car from us or not.   We also only use parts that meet your car’s manufacturer standards.',
                  type: 'text',
                },
              ],
            },
          ],
        },
        component: 'RichText',
        _editable:
          '\u003C!--#storyblok#{"name": "RichText", "space": "143588", "uid": "82248ecb-8d93-4f43-8d98-0f21d6373757", "id": "144599420828655"}--\u003E',
      },
      {
        _uid: '6787fb7e-5a56-40bd-9023-b1c4d11ad81f',
        component: 'LandingTextInlineImageSection',
        textInlineImages: [
          {
            _uid: 'aeddfb55-b776-46b1-8dad-1b9fe40bac57',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Petrol, diesel or hybrid service:',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Take your pick from three quality services to suit your needs and budget. ',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Prices:',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Oil and filter change: £129.95',
                              type: 'text',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Standard service: £159.95',
                              type: 'text',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Full service: £214.95',
                              type: 'text',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'All services include:',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Engine oil and oil filter change',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#000000',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Top-up screenwash and other fluids',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#000000',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Essential car health checks',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#000000',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'See our T&Cs',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/policies/cinch-store-goods-and-services',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                    {
                      text: " for the full list of what's included.",
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            image: {
              id: 18951200,
              alt: 'Multiple cars at a cinch service centre',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/500x333/f719b9a245/multiple-cars-at-a-cinch-service-centre.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Multiple cars at a cinch service centre',
                title: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imageShape: '',
            imagePosition: 'right',
            _editable:
              '\u003C!--#storyblok#{"name": "LandingTextInlineImage", "space": "143588", "uid": "aeddfb55-b776-46b1-8dad-1b9fe40bac57", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: '605949f8-57bb-4397-a892-62ce3433c8ae',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Electric car service:',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Keep your electric car in tip-top shape with your pick of two quality services.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Prices:',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Standard EV service: £159.95',
                              type: 'text',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Full EV service: £214.95',
                              type: 'text',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'All EV services include:',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Full diagnostics and software update(s) (if applicable)',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#000000',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'EV inspection (high-voltage components, cables, socket, battery charging status)',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#000000',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Essential car health checks',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#000000',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'See our T&Cs',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/policies/cinch-store-goods-and-services',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                    {
                      text: " for the full list of what's included.",
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            image: {
              id: 18951333,
              alt: 'Diagnostic check at cinch service centre',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/500x333/6fc16e3a05/diagnostic-check-at-cinch-service-centre.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Diagnostic check at cinch service centre',
                title: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'left',
            _editable:
              '\u003C!--#storyblok#{"name": "LandingTextInlineImage", "space": "143588", "uid": "605949f8-57bb-4397-a892-62ce3433c8ae", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: '1d09ab91-e291-4906-82a2-d93fcb9d0ae0',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'MOT',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Get your next MOT at a cinch or Marshall store for only £39.95, either on the same day as your service or separately.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 74518827608382,
              alt: 'Mechanic checks underneath car',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/1365x768/0cceac2430/mechanic-checks-underneath-car.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Mechanic checks underneath car',
                title: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'right',
            _editable:
              '\u003C!--#storyblok#{"name": "LandingTextInlineImage", "space": "143588", "uid": "1d09ab91-e291-4906-82a2-d93fcb9d0ae0", "id": "144599420828655"}--\u003E',
          },
        ],
        _editable:
          '\u003C!--#storyblok#{"name": "LandingTextInlineImageSection", "space": "143588", "uid": "6787fb7e-5a56-40bd-9023-b1c4d11ad81f", "id": "144599420828655"}--\u003E',
      },
      {
        _uid: 'ff337309-0284-49d5-aa50-e627711e6af5',
        faqs: [
          {
            _uid: 'bfa1c442-8930-4041-b4bd-086e9466f3d7',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: "Here's a list of all the locations where you can get a cinch service:",
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'A',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Ashford – Marshall BYD',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Ashford – Marshall Hyundai',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Ashford – Marshall Nissan',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'B',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Barnstaple – Marshall Audi',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Barnstaple – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Barnstaple – Marshall Volkswagen',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Beckenham – Marshall Audi South East London',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Bedford – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Bexley – Marshall Audi',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Birmingham – cinch Chery',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Blackburn – Marshall Honda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Blackburn – Marshall Mercedes-Benz',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Blackpool – Marshall Mercedes-Benz',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Blackpool – Marshall smart',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Bolton – Marshall Mercedes-Benz',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Bournemouth – Marshall BMW',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Braintree – Marshall SEAT',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Bridgwater – Marshall Volkswagen Van Centre',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'C',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Cambridge – Marshall FordStore',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Cambridge – Marshall Jaguar Land Rover',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Cambridge – Marshall SEAT',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Cambridge – Marshall Volvo',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Canterbury – Marshall Audi',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Canterbury – Marshall Hyundai',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Canterbury – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Cheltenham – Marshall Jaguar Land Rover',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Chichester – Marshall Mercedes-Benz',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Clitheroe – Marshall Honda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Coulsdon – Marshall Audi',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Coulsdon – Marshall Volkswagen',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Croydon – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'D',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Dartford – Marshall Nissan',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Dartford – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Derby – Marshall Volvo',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Doncaster – Marshall Nissan',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'E',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Exeter – Marshall Audi',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'G',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Gatwick – Marshall Hyundai',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Gatwick – Marshall OMODA & JAECOO',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Gatwick – Marshall Volkswagen',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Gloucester – Marshall Hyundai',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Grantham – Marshall Nissan',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Grimsby – Marshall BMW',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'H',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Harlow – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Harlow – Marshall Volkswagen',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Harrogate – Marshall Honda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Hereford – Marshall Hyundai',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Hook – Marshall BMW Hampshire',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Hull – Marshall Honda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'I',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Ipswich – Marshall Jaguar Land Rover',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'K',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- King’s Lynn – Marshall Ford',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'L',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Leicester – Marshall Honda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Leicester – Marshall Jaguar Land Rover',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Leicester – Marshall Nissan',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Leicester – Marshall SEAT',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Letchworth – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Letchworth – Marshall Volkswagen',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Lincoln – Marshall Jaguar Land Rover',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Lincoln – Marshall Nissan',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Lincoln – Marshall OMODA & JAECOO',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Lincoln – Marshall Volkswagen Van Centre',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Loughton – Marshall Volkswagen',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'M',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Maidstone – Marshall Audi',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Maidstone – Marshall BYD',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Maidstone – Marshall Hyundai',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Maidstone – Marshall Nissan',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Medway – cinch Chery',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Medway – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Melton Mowbray – Marshall Jaguar Land Rover',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Milton Keynes – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Milton Keynes – Marshall Volkswagen',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Milton Keynes – Marshall Volvo',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'N',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Newbury – Marshall Audi',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Newbury – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Newbury – Marshall Volkswagen',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Northampton – Marshall BYD',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Northampton – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Nottingham – Marshall OMODA & JAECOO',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Nottingham – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Nottingham – Marshall Volvo',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'O',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Oxford – Marshall Audi',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Oxford – Jaguar Land Rover',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Oxford – Marshall Nissan',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Oxford – Marshall SEAT',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Oxford – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Oxford (South Oxford) – Marshall Volkswagen',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'P',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Peterborough – Marshall BYD',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Peterborough – Marshall Honda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Peterborough – Marshall Jaguar Land Rover',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Peterborough – Marshall Volvo',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Plymouth – Marshall Audi',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Portsmouth – Marshall Mercedes-Benz',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Preston – Marshall Mercedes-Benz',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'R',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Reading – Marshall Honda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Reading – Marshall Nissan',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Reading – Marshall Škoda',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Reading – Marshall Volkswagen',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'S',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Salisbury – Marshall BMW',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Scunthorpe – Marshall BMW',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Scunthorpe – Marshall Volkswagen',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Southampton – Marshall Mercedes-Benz',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Swindon – Marshall Jaguar Land Rover',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- St Neots – Marshall BYD',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Swindon – Marshall Jaguar Land Rover',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'T',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Taunton – Marshall Audi',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Taunton – Marshall Volkswagen',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Tunbridge Wells – Marshall Audi',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'W',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Wimbledon – Marshall Audi',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Winchester – Marshall Mercedes-Benz',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Worcester – Marshall Hyundai',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Y',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- York – Marshall Honda',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            title: 'Where can I get a cinch service?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "bfa1c442-8930-4041-b4bd-086e9466f3d7", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: '691fcf28-37a4-4db0-a3c4-2981fb3b7a4b',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: "Of course. Tick both 'MOT' and your chosen service option when you fill out our ",
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                    {
                      text: 'booking form',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/car-care/servicing/book',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                    {
                      text: ',',
                      type: 'text',
                    },
                    {
                      text: ' and we’ll get you in for a service and MOT on the same day.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'Can I get my MOT done at the same time as a service?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "691fcf28-37a4-4db0-a3c4-2981fb3b7a4b", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: '3069ecaf-d08d-4751-bcca-1ebc96f7f717',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can find a full comparison of the different services we offer in our ',
                      type: 'text',
                    },
                    {
                      text: 'T&Cs',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/policies/cinch-store-goods-and-services',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                    {
                      text: ', but here are the main differences:',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Air filter change',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#242424',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Check and adjust the clutch (if needed)',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#242424',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Check the alignment',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#242424',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Check the air-con system',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#242424',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title:
              "What's included in a full service that's not in a standard service?",
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "3069ecaf-d08d-4751-bcca-1ebc96f7f717", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: '5c8a4fc0-1b98-46d8-a142-2e32c9a6276d',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can find a full comparison of the different EV services we offer in our ',
                      type: 'text',
                    },
                    {
                      text: 'T&Cs',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/policies/cinch-store-goods-and-services',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                    {
                      text: ', but here are the main differences:',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: '- Cabin air filter change',
                      type: 'text',
                    },
                    {
                      type: 'hard_break',
                    },
                    {
                      text: '- Check air-con system',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            title:
              "What's included in a full EV service that's not in a standard EV service?",
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "5c8a4fc0-1b98-46d8-a142-2e32c9a6276d", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: 'da723b35-8df5-41d2-a16e-cc51ca6ce7fd',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Most car manufacturers recommend having a standard service each year or every 12,000 miles – whichever comes first.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: "For a full service, double the time/mileage. So it's every two years or 24,000 miles. The full service replaces that year's standard service.",
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Some manufacturers recommend changing the oil every 5-7,500 miles, which is where the oil and filter change comes in.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Your car’s handbook or onboard computer will tell you how often your car should be serviced.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: "If you don’t know when your car was last serviced, let us know in the 'booking notes' section of our ",
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                    {
                      text: 'booking form',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/car-care/servicing/book',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                    {
                      text: ", and we'll be able to help.",
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'How often do I need to get my car serviced?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "da723b35-8df5-41d2-a16e-cc51ca6ce7fd", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: '40ac7e01-5bc1-4a43-a089-5a07ba431757',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'The technicians and mechanics at both cinch and Marshall stores are highly experienced and really know their cars. ',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'We also have all the equipment and expertise needed to service all types of petrol, diesel, hybrid and electric cars. Rest assured, you’re in good hands.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'How experienced and qualified are your technicians?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "40ac7e01-5bc1-4a43-a089-5a07ba431757", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: 'ca722132-7924-4f71-b6a0-350b6015c3ce',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'No, we offer servicing at cinch and Marshall stores to all drivers, whether they’ve bought a car from us or not.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'Do I need to be a cinch customer to have my car serviced?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "ca722132-7924-4f71-b6a0-350b6015c3ce", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: 'a5d21a45-0eb1-46d6-ac4e-bc7b732a76df',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Cost of parts and labour will vary depending on the make and model of car, but we’ll be fully transparent with you on all costs before any work starts – and you’re under no obligation to get the work done with us.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'How much will additional labour and parts cost?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "a5d21a45-0eb1-46d6-ac4e-bc7b732a76df", "id": "144599420828655"}--\u003E',
          },
          {
            _uid: 'ece5ab2f-8e69-4ec0-806a-abaf6e572efc',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: "We do our best to source as much service history as possible for each car we sell, but some cars don't have full service history. ",
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can view the service history for each car on its listing page on our website and app.',
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            color: '#000000',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            title: 'Do cinch cars come with a service history?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "ece5ab2f-8e69-4ec0-806a-abaf6e572efc", "id": "144599420828655"}--\u003E',
          },
        ],
        title: 'Servicing FAQs',
        component: 'FaqSection',
        _editable:
          '\u003C!--#storyblok#{"name": "FaqSection", "space": "143588", "uid": "ff337309-0284-49d5-aa50-e627711e6af5", "id": "144599420828655"}--\u003E',
      },
    ],
    hero: [
      {
        _uid: '7a7a3f3f-fd30-4fa0-a560-2b192c4c3791',
        body: 'Get your car serviced or MOT’d at 100+ locations across the country – whether you bought it from us or not. Book today.',
        logo: '',
        image: {
          id: 81176073910035,
          alt: 'Picture of a red car with a glowing spanner icon next to it',
          name: '',
          focus: '',
          title: '',
          filename:
            'https://a.storyblok.com/f/132543/900x600/79dafe0191/servicing-hero.webp',
          copyright: '',
          fieldtype: 'asset',
        },
        title: 'Book a car service or MOT with cinch',
        component: 'VapsHero',
      },
    ],
    component: 'LandingPage',
    _editable:
      '\u003C!--#storyblok#{"name": "LandingPage", "space": "143588", "uid": "c5a68e03-b65d-4a47-8002-0d4da88acfb6", "id": "144599420828655"}--\u003E',
  },
  slug: 'servicing',
  full_slug: 'servicing/',
  sort_by_date: null,
  position: -20,
  tag_list: [],
  is_startpage: true,
  parent_id: 144599263038445,
  meta_data: null,
  group_id: '59d8af6f-a3d3-4e0a-bf74-494b54220e80',
  first_published_at: '2026-02-13T14:16:50.256Z',
  lang: 'default',
  path: undefined,
  alternates: [],
  default_full_slug: undefined,
  translated_slugs: undefined,
}
